import React from 'react'
import SwitchActionButton from '../SwitchActionButton'
import { useWallet } from '@/components/common/WalletContext'

const GoToWithdraw = () => {
  const { connectEvmWallet } = useWallet()

  return (
    <SwitchActionButton
      handleSwitch={() => {
        connectEvmWallet()
      }}
    />
  )
}

export default GoToWithdraw
